import React from 'react'
import PageTitleAndSnackBar from '../../components/common/PageTitleAndSnackBar'
import SupplierList from '../../components/supplier/SupplierList'
import AddSupplier from '../../components/supplier/AddSupplier'
import SupplierTicket from '../../components/supplier/SupplierTicket'
import SupplierLedger from '../../components/supplier/SupplierLedger'
import SupplierDetails from '../../components/supplier/SupplierDetails'
import { useParams } from 'react-router-dom'
import { capitalizeFirstLetter, titleCase } from '../../helper/stringMethods'

const Supplier = () => {
    let { method } = useParams();

    return (
        <>
            {method === "ticketlist" && <PageTitleAndSnackBar pageTitle={"Supplier " + capitalizeFirstLetter(method)} />}
            {
                method === "list" && <SupplierList />
            }
            {
                method === "add" && <AddSupplier />
            }
            {
                method === "ticketlist" && <SupplierTicket />
            }
            {
                method === "ledger" && <SupplierLedger />
            }
            {
                method === "view" && <SupplierDetails />
            }

        </>
    )
}

export default Supplier